import React, { useState, useEffect } from 'react';
import apiUrl from '../../Environment/Api';
import axios from 'axios';

function TaskManagement() {
  const [getData, setGetData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [filteredData, setFilteredData] = useState([]); 

  useEffect(() => {
    getdata();
  }, []);

  //invoicelist
  const getdata = async () => {
    try {
      const response = await axios.get(apiUrl + '/invoicelist');
      console.log("invoice list data",response.data)
      setGetData(response.data);
      setFilteredData(response.data); 
    } catch (error) {
      console.log(error);
    }
  };


  // Calculate pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleItemsPerPageChange = (e) => {
    setCurrentPage(1);
    setItemsPerPage(Number(e.target.value));
  };

  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    const filteredItems = getData.filter(item => item.projectName.toLowerCase().includes(searchTerm));
    setFilteredData(filteredItems);
    setCurrentPage(1); 
  };

  return (
    <div>
      <div>
        <h5 className="mt-2">Projects</h5>
      </div>

      <hr />
      <div className="row">
        <div className="col-md-12">
         
           <div className='d-flex justify-content-between'>
        <div className='mx-2 mb-2'>
          <label>Show per page:</label>
          <select className='form-control' value={itemsPerPage} onChange={handleItemsPerPageChange}>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
          </select>
        </div>
        <form>
          <label>Search :</label>
          <input className="form-control" type="text" placeholder="Enter" onChange={handleSearch} />
        </form>
      </div>
          <div className='col-lg-12'>
            <div className="table-responsive table-responsive-data2">
              <table className="table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Client Name</th>
                    <th>Project Name</th>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Tax</th>
                    <th className='text-center'>$ Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td className="desc">{item.clientName}</td>
                      <td>{item.projectName}</td>
                      <td>{item.date}</td>
                      <td>{item.type}</td>
                      <td>{item.quantity}</td>
                      <td>{item.price}</td>
                      <td>{item.tax}</td>
                      <td className='text-center'>$ {item.totalAmount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div>
                <nav className='d-flex justify-content-end mx-2 pt-4'>
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link mx-3" onClick={() => paginate(currentPage - 1)}>
                        Previous
                      </button>
                    </li>
                    {Array.from({ length: Math.ceil(filteredData.length / itemsPerPage) }, (_, index) => (
                      <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                        <button className="page-link" onClick={() => paginate(index + 1)}>
                          {index + 1}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === Math.ceil(filteredData.length / itemsPerPage) ? 'disabled' : ''}`}>
                      <button className="page-link mx-3" onClick={() => paginate(currentPage + 1)}>
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TaskManagement;
